import script from "./LegalHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalHomePage.vue?vue&type=script&setup=true&lang=js"

import "./LegalHomePage.vue?vue&type=style&index=0&id=f22a0e40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f22a0e40"]])

export default __exports__